<template>
    <a-card>
        <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
            <a-form-item label="敏感词" name="content">
                <a-input v-model:value="searchForm.content" placeholder="请输入敏感词"/>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="onReset">重置</a-button>
            </a-form-item>
        </a-form>
        <div class="table-toolbar">
            <a-button type="primary" @click="onAdd">
                <template #icon>
                    <plus-outlined/>
                </template>
                新增
            </a-button>
        </div>
        <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
            <template #message>
                已选择 {{ selectedRowKeys.length }} 项
                <a @click="onClearSelected" class="ml-20 float-right">清空</a>
            </template>
        </a-alert>
        <a-table
            :row-selection="{type:'checkbox',selectedRowKeys:selectedRowKeys,onChange:onSelectChange}"
            :columns="columns"
            :pagination="pagination"
            :data-source="dataSource"
            :loading="loading"
            @change="onTableChange">
            <!-- <template #index="{index}">{{ index + 1 }}</template> -->
            <template #created="{text}">{{ momentFormat(text,'YYYY-MM-DD','YYYYMMDDHHmmss') }}</template>
            <template #action="{record}">
                <div class="table-row-operations">
                    <a @click="onEdit(record)">编辑</a>
                    <a-popconfirm title="确认要删除吗?" @confirm="onDelete(record.key)">
                        <a class="delete">删除</a>
                    </a-popconfirm>
                </div>
            </template>
        </a-table>
    </a-card>
    <div class="table-footer-bar-out" v-if="selectedRowKeys.length">
        <div class="table-footer-bar">
            <div class="table-footer-bar-left">
                已选择 <a>{{ selectedRowKeys.length }}</a> 项
            </div>
            <div class="table-footer-bar-right">
                <a-button danger @click="onBatch(deleteBatchUrl)">批量删除</a-button>
            </div>
        </div>
    </div>
    <AddOrEditModal ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
</template>
<script>
import {tableListMixin} from "@/mixins";
import AddOrEditModal from "./components/AddOrEditModal";
import {sensitive_words} from "@/api/adminService";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {title: "敏感词", dataIndex: "content", key: "content"},
    {title: "创建时间", dataIndex: "created", key: "created",slots: {customRender: "created"}},
    {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},
];
export default {
    name: "index",
    mixins: [tableListMixin],
    components: {
        AddOrEditModal,
    },
    data() {
        return {
            columns,
            queryParam: {},
            listUrl: sensitive_words.getSensitiveWordsListData,
            listKeyField: "id",
            deleteUrl: sensitive_words.remove,
            deleteBatchUrl: sensitive_words.deleteBatch,
        }
    },
    methods: {
        onAdd() {
            this.onShowModal("modal");
        },
        onEdit(record) {
            this.onShowModal("modal", record);
        }
    }
}
</script>
<style scoped lang="less">
</style>
